"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Pagination", {
    enumerable: true,
    get: function() {
        return Pagination;
    }
});
var _react = /*#__PURE__*/ _interopRequireDefault(require("react"));
var _button = require("../Button");
var _loadingBar = require("../LoadingBar");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var Pagination = function(props) {
    var total = props.total, current = props.current, pageSize = props.pageSize, onPrev = props.onPrev, onNext = props.onNext, nextPageLoading = props.nextPageLoading, prevPageLoading = props.prevPageLoading;
    var from = pageSize * current + 1;
    var to = Math.min((current + 1) * pageSize, total);
    var nextDisabled = Math.ceil(total / pageSize) === current + 1;
    return /*#__PURE__*/ _react.default.createElement("nav", {
        className: "bg-white px-4 py-3 flex items-center justify-between border-b border-l border-r border-gray-200 sm:px-6 sm:rounded-b-lg",
        "aria-label": "Pagination"
    }, /*#__PURE__*/ _react.default.createElement("div", {
        className: "hidden sm:block"
    }, /*#__PURE__*/ _react.default.createElement("p", {
        className: "text-sm text-gray-700"
    }, "Showing ", /*#__PURE__*/ _react.default.createElement("span", {
        className: "font-medium"
    }, from), " to", " ", /*#__PURE__*/ _react.default.createElement("span", {
        className: "font-medium"
    }, to), " of ", /*#__PURE__*/ _react.default.createElement("span", {
        className: "font-medium"
    }, total), " ", "results")), /*#__PURE__*/ _react.default.createElement("div", {
        className: "flex-1 flex justify-between sm:justify-end"
    }, /*#__PURE__*/ _react.default.createElement(_button.ButtonDefault, {
        disabled: current === 0,
        onClick: function() {
            return onPrev && onPrev();
        }
    }, prevPageLoading && /*#__PURE__*/ _react.default.createElement("div", {
        className: "mr-2"
    }, /*#__PURE__*/ _react.default.createElement(_loadingBar.LoadingBar, {
        size: "sm"
    })), " ", "Previous"), /*#__PURE__*/ _react.default.createElement(_button.ButtonDefault, {
        className: "ml-3",
        onClick: function() {
            return onNext && onNext();
        },
        disabled: nextDisabled || nextPageLoading
    }, nextPageLoading && /*#__PURE__*/ _react.default.createElement("div", {
        className: "mr-2"
    }, /*#__PURE__*/ _react.default.createElement(_loadingBar.LoadingBar, {
        size: "sm"
    })), "Next")));
};

//# sourceMappingURL=Pagination.js.map